cv.PreviewView = Marionette.LayoutView.extend({
  el: "body",

  regions: {},

  events: {},

  initialize: function (options) {
    this.options = _.extend(this.options, options);

    // Setup trigger
    this.listenTo(vent, "editor:highlight_element", this.highlightElement, this);
    this.listenTo(vent, "editor:remove_highlight", this.removeHighlight, this);
    this.listenTo(vent, "editor:change_color", this.changeColor, this);

    // Pass recalculation of height
    if (window.name == "cv_editor") {
      parent.cv.iframeTrigger("editor:iframe_recalculate", $("body").prop("scrollHeight"));
    }

    // Bind the toolbar
    this.$el.prepend('<div class="cv-toolbar"></div>');

    // Bind any body clicks to de-activate fields
    this.$el.on("click", function (e) {
      // Clear any fields
      vent.trigger("editor:clear_fields");

      // Hide the toolbar
      parent.cv.iframeTrigger("editor:hide_toolbar");
    });

    // If we have an iframe class then disable clicks to it
    this.$(".iframe").css("position", "relative");
    this.$(".iframe").prepend(
      '<div style="position: absolute; left: 0; top: 0; height: 100%; width: 100%; background: (0,0,0,0); z-index: 5;"></div>'
    );

    // Any clicks on the window
    this.$("a").on("click", function (e) {
      e.preventDefault();
      return false;
    });

    // HACK for donation form
    this.$(".tier, .preview-recipient .value").on("click", function (e) {
      e.preventDefault();
      return false;
    });

    // Bind fields
    _.each(
      cv.PRELOADED.fields,
      function (field, key, list) {
        if (this.$("#cv-field-" + key).length > 0) {
          // Create the region
          var region = {};
          var key = this.$("#cv-field-" + key)
            .attr("id")
            .split("-")[2];
          region[key] = "#cv-field-" + key;

          // Add the region
          this.addRegions(region);
          var model = new Backbone.Model(cv.PRELOADED.fields[key]);
          model.set("id", key);

          // Attach the view
          this[key].attachView(
            new cv.FieldView({
              el: "#cv-field-" + key,
              model: model,
            })
          );
        }
      },
      this
    );

    console.log("PreviewView initialized");
  },

  changeColor: function (model) {
    var new_color = {};

    // Render the color
    new_color[model.get("attribute")] = model.get("value");

    // Render the background
    if (!_.isUndefined(model.get("url"))) {
      new_color["background-image"] =
        "url(" +
        cv.photo({
          photo_path: model.get("url"),
          transforms: {},
          url_only: true,
        }) +
        ")";
      new_color["background-repeat"] = model.get("repeat");
      new_color["background-position"] = model.get("ypos") + " " + model.get("xpos");

      setTimeout(
        _.bind(function () {
          $(this).remove(); // prevent memory leaks as @benweet suggested

          // Render
          this.$(model.get("element")).css(new_color);
        }, this),
        250
      );
    } else {
      // Render
      this.$(model.get("element")).css(new_color);
    }
  },

  highlightElement: function (key) {
    $elements = $(cv.PRELOADED.fields[key].element);

    _.each(
      $elements,
      function (el, key, list) {
        var $outline = $('<div class="cv-color-outline"></div>');
        $outline.css({
          left: $(el).offset().left,
          top: $(el).offset().top,
          width: $(el).outerWidth(),
          height: $(el).outerHeight(),
        });
        this.$el.append($outline);
      },
      this
    );
  },

  removeHighlight: function (id) {
    this.$(".cv-color-outline").remove();
  },

  templateHelpers: function () {
    return {};
  },

  onAttach: function () {
    alert("asdfaf");

    // Add class to body
    this.$("body").addClass("in-preview");
  },

  onDestroy: function () {},
});
